import * as styles from "@/styles/modules/Container.module.scss"

const Container = ({
  children,
  className,
}: React.PropsWithChildren<{ className?: string }>) => {
  return (
    <div className={`${styles.container} ${className ? className : ""}`}>
      {children}
    </div>
  )
}

export default Container
